"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostFeature = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const post_styles_1 = require("@/components/domains/post/post.styles");
const shared_styles_1 = require("@/stylesheets/shared.styles");
require("@/components/common");
/**
 * 목록 맨 위에서 한 편을 크게 내세우는 글 카드.
 * post-item과 같은 링크 표면을 쓰되 썸네일을 넓게 두고 제목·설명을 아래로 쌓는다.
 */
let PostFeature = class PostFeature extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.href = '';
        this.thumbnail = '';
        this.title = '';
        this.description = '';
        this.date = '';
    }
    render() {
        const body = (0, lit_1.html) `
      <mm-thumbnail src=${this.thumbnail} ratio="16:9"></mm-thumbnail>
      <mm-text as="time" size="12" color="light">${this.date}</mm-text>
      <mm-text size="24" weight="bold">${this.title}</mm-text>
      <mm-paragraph color="light">${this.description}</mm-paragraph>
    `;
        if (!this.href) {
            return (0, lit_1.html) `
        <div class="link">${body}</div>
      `;
        }
        return (0, lit_1.html) `
      <a class="link" href=${this.href}>${body}</a>
    `;
    }
};
PostFeature.styles = [
    shared_styles_1.resetStyles,
    post_styles_1.postLinkStyles,
    (0, lit_1.css) `
      :host {
        display: block;
      }

      .link {
        flex-direction: column;
        gap: var(--space-3);
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PostFeature.prototype, "href", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PostFeature.prototype, "thumbnail", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PostFeature.prototype, "title", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PostFeature.prototype, "description", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PostFeature.prototype, "date", void 0);
PostFeature = __decorate([
    (0, decorators_js_1.customElement)('mm-post-feature')
], PostFeature);
exports.PostFeature = PostFeature;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9zdC1mZWF0dXJlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicG9zdC1mZWF0dXJlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBMkQ7QUFFM0QsdUVBQXNFO0FBQ3RFLCtEQUF5RDtBQUN6RCwrQkFBNEI7QUFFNUI7OztHQUdHO0FBRUksSUFBTSxXQUFXLEdBQWpCLE1BQU0sV0FBWSxTQUFRLGdCQUFVO0lBQXBDOztRQWV1QixTQUFJLEdBQUcsRUFBRSxDQUFBO1FBQ1QsY0FBUyxHQUFHLEVBQUUsQ0FBQTtRQUNkLFVBQUssR0FBRyxFQUFFLENBQUE7UUFDVixnQkFBVyxHQUFHLEVBQUUsQ0FBQTtRQUNoQixTQUFJLEdBQUcsRUFBRSxDQUFBO0lBb0J2QyxDQUFDO0lBbEJDLE1BQU07UUFDSixNQUFNLElBQUksR0FBRyxJQUFBLFVBQUksRUFBQTswQkFDSyxJQUFJLENBQUMsU0FBUzttREFDVyxJQUFJLENBQUMsSUFBSTt5Q0FDbkIsSUFBSSxDQUFDLEtBQUs7b0NBQ2YsSUFBSSxDQUFDLFdBQVc7S0FDL0MsQ0FBQTtRQUVELElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFFO1lBQ2QsT0FBTyxJQUFBLFVBQUksRUFBQTs0QkFDVyxJQUFJO09BQ3pCLENBQUE7U0FDRjtRQUVELE9BQU8sSUFBQSxVQUFJLEVBQUE7NkJBQ2MsSUFBSSxDQUFDLElBQUksSUFBSSxJQUFJO0tBQ3pDLENBQUE7SUFDSCxDQUFDOztBQXJDTSxrQkFBTSxHQUFHO0lBQ2QsMkJBQVc7SUFDWCw0QkFBYztJQUNkLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7S0FTRjtDQUNGLENBQUE7QUFDMkI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3lDQUFVO0FBQ1Q7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzhDQUFlO0FBQ2Q7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzBDQUFXO0FBQ1Y7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO2dEQUFpQjtBQUNoQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7eUNBQVU7QUFuQjFCLFdBQVc7SUFEdkIsSUFBQSw2QkFBYSxFQUFDLGlCQUFpQixDQUFDO0dBQ3BCLFdBQVcsQ0F1Q3ZCO0FBdkNZLGtDQUFXIn0=